const remBase = 16;

const pageContent = (backgroundGrey: boolean) => {
    return {
        minHeight: "100%",
        backgroundColor: backgroundGrey ? "grey.100" : "common.white",
        padding: `${spacing(18)} 2% ${spacing(6)} 2%}`
    }
}

const toRem = (pxValue: number) => (pxValue / remBase) + 'rem';

const spacing = (multi: number) => (toRem((multi === undefined ? 2 : multi) * 8));

export {toRem, spacing, pageContent}